<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Formularze'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-dynamic-forms-details-view *ngIf="!modify" [dynamicForm]="dynamicForm"  (modifyClicked)="modify = true;"></app-dynamic-forms-details-view>
    <app-add-dynamic-form *ngIf="modify" [dynamicForm]="dynamicForm"  (closeModification)="modify = false; load()" ></app-add-dynamic-form>

  </mat-tab>
  <mat-tab label="Lista zgłoszeń">
    <app-dynamic-form-apply-list   [embeddedView]="true" [dynamicFormId]="dynamicFormId" (closeModification)="modify = false;"></app-dynamic-form-apply-list>
  </mat-tab>

</mat-tab-group>

